var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { attrs: { id: "menu" } },
    [
      _c("div", { staticClass: "d-flex mb-3 justify-content-between" }, [
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("back")
              },
            },
          },
          [_c("i", { staticClass: "far fa-chevron-left fa-1x" })]
        ),
        _c("h4", { staticClass: "text-center" }, [_vm._v("Navigation")]),
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_c("i", { staticClass: "far fa-times fa-1x" })]
        ),
      ]),
      _c("forms", {
        staticClass: "m-1",
        attrs: { scheme: _vm.data.propsScheme, name: "NavBar" },
        on: { submitNavBar: _vm.submitNavBar },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }